import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { CoupletContext } from './App';
import copy from 'copy-to-clipboard';

function ShowCouplet() {
  let history = useHistory();
  const [couplet, setCouplet] = useContext(CoupletContext);
  const [showMsg, setShowMsg] = useState(false);
  const [message, setMessage] = useState("");
  const [showImg, setShowImg] = useState(false);
  const [imgLink, setImgLink] = useState("");

  function backToHome() {
    setCouplet({});
    history.push('/');
  };

  function handleSubmit() {
    setShowMsg(true);
    setMessage("请您稍等...");
    // send input Couplet to server
    var data_first_couplet = {
      'first_couplet': couplet.first_couplet
    };
    axios.post(process.env.REACT_APP_BACKEND_IP + '/getcouplet', JSON.stringify(data_first_couplet))
      .then(function (response) {
        // console.log(response);
        // success get couplet id
        var code = response.data.code;
        var celery_id = response.data.celery_id;
        if (code === '0') {
          var data_celery_id = {
            'celery_id': celery_id
          };
          var limit = 0;
          var a = setInterval(function() {
            limit += 1
            if (limit >= 20) {
              // get couplet failed
              setMessage("出错了，请重试...");
              clearInterval(a);
            } else {
              axios.post(process.env.REACT_APP_BACKEND_IP + '/sendcouplet', JSON.stringify(data_celery_id))
              .then(function (response) {
                // success get couplet
                var status = response.data.status;
                var couplet2 = response.data.couplet;
                if (status === 'SUCCESS') {
                  setCouplet({
                    'first_couplet': couplet.first_couplet, 
                    'second_couplet': couplet2
                  });
                  console.log(couplet);
                  setShowMsg(false);
                  clearInterval(a);
                } else if (status === 'FAILED') {
                  // failed to get couplet
                  setMessage("出错了，请重试...");
                  clearInterval(a);
                } else if (status === 'NOOUTPUT') {
                  // failed to get couplet
                  setMessage("抱歉，对您出的这个上联，我江郎才尽了。您可另出一上联");
                  clearInterval(a);
                }
              })
              .catch(function (error) {
                console.log(error);
                // get couplet failed
                setMessage("出错了，请重试...");
                clearInterval(a);
              })
            }
          }, 500);
        } else {
          // input error
          setMessage("出错了，请重试...");
        }
    })
    .catch(function (error) { 
        console.log(error);
        // getCouplet id failed
        setMessage("出错了，请重试...");
    })
  };

  function toShare() {
    setShowMsg(true);
    setMessage("请您稍等...");
    // send input Couplet to server
    var data_couplet = {
      'first_couplet': couplet.first_couplet,
      'second_couplet': couplet.second_couplet
    };
    axios.post(process.env.REACT_APP_BACKEND_IP + '/getImg', JSON.stringify(data_couplet))
      .then(function (response) {
        var status = response.data.status;
        var getImgLink = response.data.link;
        if (status === "SUCCESS") {
          setShowMsg(false);
          const time = new Date().getTime();
          getImgLink = `${getImgLink}?time=${time}`;
          setImgLink(getImgLink);
          setShowImg(true);
          console.log(imgLink);
        } else {
          console.log("failed to generate couplet image");
          setMessage("出错了，请重试...");
        }
      })
      .catch(function (error) {
        console.log(process.env)
        console.log(error);
        setMessage("出错了，请重试...");
      })
  };
  // function closeImg() {
  //   setShowImg(false);
  // }
  function copyToClipBoard() {
    try{
      copy("https://nlp.csai.tsinghua.edu.cn/jiuge/couplet");
      alert("已复制链接至剪切板");
    } catch {
      alert("未能复制链接，设备不支持");
    }
  };

  const footer = (
    <div>
      <div className="fixed inset-x-0 bottom-0 text-center h-auto md:h-36 md:text-xl bg-white">
          <br />
          <p>清华大学</p>
          <p>自然语言处理实验室</p>
          <p>九歌: <a href="http://jiuge.thunlp.org">jiuge.thunlp.org</a></p>
          <br />
      </div>
      <img className="fixed bottom-3 md: bottom-5 left-1 md:left-12 w-20 h-20 md:w-28 md:h-28" src="../images/qrJiuge.png" alt='九歌二维码'/>
      <img className="fixed bottom-3 md: bottom-5 right-1 md:right-12 w-20 h-20 md:w-28 md:h-28" src="../images/qrTHUNLP.jpg" alt='THUNLP公众号二维码' />
    </div>
  );

  if (JSON.stringify(couplet) === '{}') {
    history.push('/');
    return (
      <div></div>
    );
  } else {
    return (
      <div>
        {showImg ? <div className="mx-auto h-full min-h-screen w-full p-1" style={{backgroundImage: "url('../images/bg3Pure.jpg')", backgroundSize: "cover"}}>
          <div className="w-full h-full m-auto flex grid inset-0 place-content-center" style={{minHeight: '98vh'}}>
            <div className="m-auto rounded-3xl p-2 bg-white bg-opacity-30 w-72 md:w-8/25">
            <img className="object-fill" src={imgLink} alt="对联图片生成失败，请重试..." />
            <p className="text-center text-lg md:text-xl text-yellow-400 place-self-center">您可右键单击下载图片</p>
            </div>
            <div className="p-4 md:m-auto md:w-7/20">
              <button className="focus:outline-none float-left p-2 place-self-center" onClick={backToHome}>
                <img className="w-24 h-8 md:w-28 md:h-10" src="../images/btnReinput2.png" alt="另出上联"/>
              </button>
              <button className="focus:outline-none float-right p-2 place-self-center" onClick={copyToClipBoard}>
                <img className="w-24 h-8 md:w-28 md:h-10" src="../images/btnCpLink.png" alt="复制链接"/>
              </button>
            </div>
          </div>
        </div>:
        <div className="overflow-auto w-screen mx-auto h-screen" style={{backgroundImage: "url('../images/bg2Pure.jpg')", backgroundSize: "cover"}}>
          <div className="container h-4/5 m-auto flex grid gap-5 place-content-center">
            <img className="fixed right-1 top-1 w-20 h-20 md:w-60 md:h-60" src="../images/fireworks.png" alt="" />
            <img className="fixed left-0 bottom-32 md:bottom-40 w-16 h-20 md:w-56 md:h-60" src="../images/meihua.png" alt="" />
            <img className="fixed right-1 bottom-32 md:bottom-40 w-28 h-16 md:w-64 md:h-32" src="../images/duiduiziLogo.png" alt="" />
            <a className="fixed top-2 left-2" href="http://jiuge.thunlp.org">
              <img className="w-8 md:w-20 h-14 md:h-36" src="../images/jiugeLogoGold.png" alt="" />
            </a>
            <div className="p-4 md:p-8" style={{backgroundImage: "url('../images/frame.png')", backgroundSize: "100% 100%"}}>
              <p className="text-center text-xl md:text-3xl text-yellow-400 place-self-center">为您生成的对联:</p>
              {couplet.first_couplet.length <= 7 ? 
                <div className="text-center text-yellow-400 text-3xl md:text-4xl">
                  <p className="p-0.5 md:p-3">上联: {couplet.first_couplet}</p>
                  <p className="p-0.5 md:p-3">下联: {couplet.second_couplet}</p>
                </div> : null
              }
              {couplet.first_couplet.length > 7 && couplet.first_couplet.length <= 10? 
                <div className="text-center text-yellow-400 text-2xl md:text-4xl">
                  <p className="p-0.5 md:p-3">上联: {couplet.first_couplet}</p>
                  <p className="p-0.5 md:p-3">下联: {couplet.second_couplet}</p>
                </div> : null
              }
              {couplet.first_couplet.length > 10 && couplet.first_couplet.length <= 12? 
                <div className="text-center text-yellow-400 text-xl md:text-3xl">
                  <p className="p-0.5 md:p-3">上联: {couplet.first_couplet}</p>
                  <p className="p-0.5 md:p-3">下联: {couplet.second_couplet}</p>
                </div> : null
              }
              {couplet.first_couplet.length > 12?  
                <div className="text-center text-yellow-400 text-lg md:text-3xl">
                  <p className="p-0.5 md:p-3">上联: {couplet.first_couplet}</p>
                  <p className="p-0.5 md:p-3">下联: {couplet.second_couplet}</p>
                </div> : null
              }
            </div>
            <p className="text-2xl md:text-3xl text-yellow-400 place-self-center" hidden={!showMsg}>{message}</p>
            <br />
            <div className="relative mx-auto inset-x-0 text-center">
              <button className="focus:outline-none w-full place-self-center py-2 rounded-2xl" onClick={handleSubmit}>
                <img className="inline w-44 h-8 md:w-60 md:h-12" src="../images/btnAnother.png" alt="不满意？换一首"/>
              </button>
              <button className="focus:outline-none w-full place-self-center py-2 rounded-2xl" onClick={backToHome}>
                <img className="inline w-44 h-8 md:w-60 md:h-12" src="../images/btnReinput1.png" alt="另出上联"/>
              </button>
              <button className="focus:outline-none w-full place-self-center py-2 rounded-2xl" onClick={toShare}>
                <img className="inline w-44 h-8 md:w-60 md:h-12" src="../images/btnSave.png" alt="保存分享"/>
              </button>
            </div>
          </div>
          {footer}
        </div>}
      </div>
    );
  }
};

export default ShowCouplet;